import styled from 'styled-components';
import { minBp } from '@triumph/shared';

export const Wrap = styled.div`
  background-color: white;
  box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 24px;

  @media ${minBp('tablet')} {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`;

export const ContentWrap = styled.div`
  @media ${minBp('tablet')} {
    min-height: 155px;
    flex: 1;
  }

  @media ${minBp('desktop')} {
    flex: 2;
  }
`;

export const Content = styled.div`
  padding: 25px 20px;

  @media ${minBp('tablet')} {
    padding: 35px;
  }

  @media ${minBp('desktop')} {
    padding: 44px 62px;
  }
`;

export const Title = styled.h3`
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 10px;
  padding-right: 22px;
  position: relative;
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    font-size: 25px;
    line-height: 32px;
    margin-bottom: 8px;
  }
`;

export const InfoIconBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0 8px 6px;
  position: absolute;
  width: 22px;
  height: 22px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media ${minBp('desktop')} {
    margin: 2px 0 2px 10px;
  }
`;

export const Description = styled.p`
  font-size: 14px;
  margin-bottom: 0;

  @media ${minBp('desktop')} {
    font-size: 16px;
  }
`;

export const ImageWrap = styled.div`
  width: 100%;
  height: 184px;

  @media ${minBp('tablet')} {
    flex: 1;
    height: initial;
    position: relative;

    picture {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  }
`;
